import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const headerHeight = document.querySelector('.main-header').offsetHeight;

document.addEventListener('DOMContentLoaded', () => {
    const serviceSection = document.querySelectorAll('.our-services-section');

    serviceSection.forEach(section => {
        const cards = section.querySelectorAll('.oss-item');
        const stickDistance = 0;
    
        ScrollTrigger.create({
            trigger: cards[0],
            start: `top +${headerHeight}px`,
        });
    
        const lastCardST = ScrollTrigger.create({
            trigger: cards[cards.length - 1],
            start: `top +${headerHeight}px`,
        });
    
        cards.forEach((card, index) => {
            const scale = 1 - (cards.length - index) * 0.025;
            const scaleDown = gsap.to(card, {
                scale: scale,
                'transform-origin': '"50% ' + (lastCardST.start + stickDistance) + '"',
            });
    
            ScrollTrigger.create({
                trigger: card,
                start: `top +${headerHeight}px`,
                end: () => lastCardST.start + stickDistance,
                pin: true,
                markers: false,
                pinSpacing: false,
                ease: 'none',
                animation: scaleDown,
                toggleActions: 'restart none none reverse',
            });
        });
    });
});